import type { ApiErrorDataI } from 'declarations/interfaces/errors';

export const extractErrorExtensionField = (
  errorDetails: ApiErrorDataI,
  fieldName: keyof ApiErrorDataI
): string | undefined => {
  const directValue = errorDetails[fieldName];
  if (typeof directValue === 'string') {
    return directValue;
  }

  const extensions = (errorDetails.extensions ?? {}) as Record<string, unknown>;
  const extensionValue = extensions[fieldName];
  if (typeof extensionValue === 'string') {
    return extensionValue;
  }

  return undefined;
};
